const types = {
	popup : {
		feature : false,
		name    : 'Popup',
	},
	floating : {
		videoUrl : 'https://www.youtube.com/embed/6OBk0GnfMi0',
		feature  : 'floating-bar',
		name     : 'Floating Bar',
	},
	fullscreen : {
		videoUrl : 'https://www.youtube.com/embed/eLJ1oNVC5dA',
		feature  : 'fullscreen',
		name     : 'Fullscreen',
	},
	inline : {
		videoUrl : 'https://www.youtube.com/embed/G2nmRV4tU7A',
		feature  : 'inline',
		name     : 'Inline',
	},
	slide : {
		videoUrl : 'https://www.youtube.com/embed/Mr7UkNZJ1lA',
		feature  : 'slide-in',
		name     : 'Slide-in',
	},
	gamified : {
		videoUrl : 'https://www.youtube.com/embed/EBQ50TVaVCk',
		feature  : 'coupon-wheel-campaigns',
		name     : 'Gamified',
	},
}

const recentTemplates = {}
const popular = {}

Object.keys(types).forEach((type) => {
	recentTemplates[type] = []
	popular[type] = []
})

export default {
	activeType     : 'popup',
	activeTemplate : {},
	loadingPreview : '',
	previewing     : '',
	sort           : 'recent',
	search         : '',
	apiLoaded      : false,
	filterOptions  : [
		[ {
			slug   : 'device',
			values : [],
		} ],
		[ {
			slug   : 'categories',
			values : [],
		} ],
		[ {
			slug   : 'goals',
			values : [],
		} ],
		[ {
			slug   : 'tags',
			values : [],
		} ],
	],
	filters : {
		device     : 'desktop',
		categories : [],
		goals      : [],
		tags       : [],
	},
	permittedTypes : [],
	templates      : [],
	popular,
	recentTemplates,
	types,
}
